import { render } from "./MosaicoCard.vue?vue&type=template&id=f18f090a&scoped=true"
import script from "./MosaicoCard.vue?vue&type=script&lang=js"
export * from "./MosaicoCard.vue?vue&type=script&lang=js"

import "./MosaicoCard.vue?vue&type=style&index=0&id=f18f090a&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18f090a"]])

export default __exports__